import { Button } from "components/atoms";
import { FormInput } from "components/molecules";
import { useTranslation } from "react-i18next";
import { PiTrash } from "react-icons/pi";
import { useGetLanguages } from "services/enums";
import { IVideoSubtitles } from "services/video/types";
import { BUTTON_VARIANT } from "types/components/button/button.interface";
import { getLanguageSelectOptions } from "utils/global/language.utils";
import "./SubtitlesCard.scss";

interface ISubtitlesCardProps {
  subtitle: IVideoSubtitles;
  index: number;
  displayMode?: boolean;
  onRemove?: () => void;
}

const SubtitlesCard = ({
  subtitle,
  index,
  displayMode,
  onRemove,
}: ISubtitlesCardProps) => {
  const { t } = useTranslation();
  const languages = useGetLanguages();
  return (
    <div className="subtitles-card">
      {displayMode ? (
        <div className="subtitles-name">
          <div className="subtitles-header">
            {t(`enum.LANGUAGE.${subtitle.language}`)}
          </div>
          <div className="subtitles-footer">{subtitle.subtitles}</div>
        </div>
      ) : (
        <div className="subtitles-inputs">
          <FormInput.Select
            name={`subtitles[${index}].language`}
            label={t("input.label.language")}
            value={{
              value: subtitle.language,
              label: t(`enum.LANGUAGE.${subtitle.language}`),
            }}
            options={getLanguageSelectOptions(languages.data)}
            appBackground
          />
          <FormInput.Field
            name={`subtitles[${index}].subtitles`}
            label={t("input.label.subtitles")}
            style={{
              height: 200,
              resize: "none",
              width: "100%",
              maxWidth: "100%",
            }}
            appBackground
          />
        </div>
      )}
      {!displayMode && (
        <Button
          isClear
          onlyIcon
          variant={BUTTON_VARIANT.remove}
          onClick={onRemove}
        >
          <Button.Icon icon={<PiTrash />} />
        </Button>
      )}
    </div>
  );
};

export default SubtitlesCard;
